import "./DashboardBarCard.css";

import { BarChart, Column, ExpandableCard, Row } from "../../../../../widget";

export interface DashboardBarCardProps {
  data: { [key: string]: number };
  title: string;
  expandRoute?: string;
}

export const DashboardBarCard = ({ data, title, expandRoute }: DashboardBarCardProps): JSX.Element => {
  return (
    <ExpandableCard title={title} targetRoute={expandRoute}>
      <Row className="DashboardBarCardRow">
        <Column span={12}>
          <BarChart data={data} />
        </Column>
      </Row>
    </ExpandableCard>
  );
};
